/**
 * @deprecated you likely want to use `stringifyParams` or `stringifyUrl` from `src/utils/params.ts` instead
 */
export const buildQueryStringList = (params: Record<string, unknown>) => {
  if (!params || !Object.keys(params).length) return ''

  const queryStringList = []

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      queryStringList.push(`${key}=${value}`)
    }
  })

  return `?${queryStringList.join('&')}`
}
